<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Street"
      id="admin_view_street_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        :to="'/admin/locations/streets/view/' + $route.params.id + '/edit'"
        small
        rounded
        class="mr-4"
        outlined
        color="warning"
      >
        <v-icon left>mdi-pen</v-icon>Edit Street
      </v-btn>
      <v-btn
        :to="'/admin/locations/streets/view/' + $route.params.id + '/delete'"
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-times</v-icon> Remove Street
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="street.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606031411/botswana%20services/website%20assets/street_ypavnx.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Businesses In This Street"
      id="admin_view_street_businesses"
    ></CardedSectionHeader>
    <CardedDisplay>
      <CardedTable
        :items="businesses"
        :headers="business_headers"
        :show_description="true"
      >
        <template v-slot:[`item.owner`]="{ item }">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </template>
        <template v-slot:description>
          <p class="text-left ml-4 mr-4">
            This ward has {{ businesses.length }} businesses
          </p>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="view_business(item)"  x-small rounded text color="success">
            <v-icon>mdi-eye</v-icon> 
          </v-btn>
        </template> 
      </CardedTable>
    </CardedDisplay>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminStreetsView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      street: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        },
        ward: {
            id: 0,
            name: ""
        }
      },
      businesses: [],
      business_headers: [
        { text: "Name", value: "name" },
        { text: "Phone Number", value: "office_phone_number1", sortable: false  },
        { text: "Owner", value: "owner", sortable: false  },
        { text: "Description", value: "description", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
          {
              text: "Ward",
              val: this.street.ward.name
          },
        {
          text: "City",
          val: this.street.city.name,
        },
        { text: "District:", val: this.street.district.name },
        { text: "Country:", val: this.street.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var street_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Street Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Streets",
          disabled: false,
          href: "/admin/locations/streets/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/locations/streets/view/" + street_id,
        },
      ],
    });
    this.$emit("on-show-loader");
    ServerClient.Locations.get_street(
      {
        id: street_id,
        is_admin: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.street = res.street;
        this.businesses = res.businesses;
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log("Errors while loading street details on admin", errors);
      }
    );
  },
  methods: {
    view_business(business) {
      this.$router.push("/admin/businesses/view/" + business.id);
    },
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>